import useWingitnorthOutliers, {
  wingitnorthOutliersConfigs,
} from './useOutliers'

export const configs = {
  wingitnorthOutliers: wingitnorthOutliersConfigs,
}

export const api = {
  wingitnorthOutliers: useWingitnorthOutliers,
}
